import './App.css';
import './constant.css';
import './common.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Homepage from './Homepage/homepage';
import EventsPage from './EventsPage/eventspage';
import PaymentStatus from './Components/PaymentStatus';
import PrivacyPage from './PrivacyPage/privacy'
import TermsPage from "./TermsPage/Terms";
import AboutPage from "./AboutPage/About"
import EventsListing from "./EventsListing/eventsListing"
import MembershipPage from './MembershipPage/MembershipPage';
import ComingSoon from './MembershipPage/ComingSoon';
import ScrollToTop from './Components/ScrollToTop';
import OrderPaymentCompletion from './Components/OrderPaymentCompletion';
import OrderPaymentEventPage from './EventsPage/CurrentEvent/orderPaymentEventPage';
import AccountDeletePage from './AccountDeletePage/AccountDelete';
import GoodbyePage from './GoodbyePage/goodbye';


function App() {



  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        {/* <Route path="/events/:eventId/:paymentId" element={<EventsPage />} /> */}
        <Route path="/events/:eventId/" element={<EventsPage />} />
        
        <Route path="/events-listing" element={<EventsListing />} /> 
        <Route path="/events-listing/:paymentId" element={<EventsListing />} /> 
        {/* <Route path="/events" element={<EventsPage />} /> */}
        <Route path="/payments/:paymentId" element={<PaymentStatus />} />
        <Route path='/privacy' element={<PrivacyPage />}/>
        <Route path='/terms' element={<TermsPage />}/>
        <Route path='/about' element={<AboutPage />} />
        <Route path='/account/delete' element={<AccountDeletePage />} />
        <Route path='/goodbye' element={<GoodbyePage />} />
        <Route path='/membership/:paymentId' element={<MembershipPage />}/>
        <Route path='/membership' element={<MembershipPage />}/>
        {/* <Route path='/membership/:paymentId' element={<ComingSoon />}/>
        <Route path='/membership' element={<ComingSoon />}/> */}
        <Route path='/user/sub_order/:suborderId' element={<OrderPaymentCompletion />} />
        <Route path='/events/orderpayment/:eventId' element={<OrderPaymentEventPage />} />
        
      </Routes>
    </Router>
  );
}

export default App;
